import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import { Observable } from 'rxjs';

import { HomesService } from '../../../services/homes.service';
import {LandingArea} from "../../../models/homes/landing-area";

@Injectable()
export class WidgetCOHOPreviewsResolver implements Resolve<LandingArea> {

    constructor(private homesService: HomesService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<LandingArea> {


        let locationReference = route.paramMap.get('locationReference');
        let tenantType= null;
        let enSuite = false;
        let noDeposit = false;
        let maxhomes = 3;

        if (route.queryParams['type']) {
            tenantType = route.queryParams['type'];
        }

        if (route.queryParams['enSuite']) {
            enSuite = route.queryParams['enSuite'] == 1;
        }

        if (route.queryParams['noDeposit']) {
            noDeposit = route.queryParams['noDeposit'] == 1;
        }

        if (route.queryParams['maxhomes']) {
            maxhomes = parseInt(route.queryParams['maxhomes'], 10); 
        }

        return this.homesService.getLandingArea(locationReference, tenantType, noDeposit, enSuite, maxhomes);
    }
}
